import React, {createContext, ReactNode, useContext, useState} from 'react'
import {useUIGameSocketContext} from '../../contexts/UIGameSocketContext'
import {useUIGameReplayContext} from '../../contexts/UIGameReplayContext'

interface UIGamePauseContextProps {
    isPaused: boolean
    remainingPauseTimeMS: number | undefined
    requestPause: () => void
    requestResume: () => void
}

const UIGamePauseContext = createContext<UIGamePauseContextProps | undefined>(undefined)

export const useUIGamePauseContext = () => {
    const context = useContext(UIGamePauseContext)
    if(!context) throw new Error('UIGamePauseContext not found')
    return context
}

let globalIsPaused: undefined | ((isPaused: boolean) => void)
export function setGlobalIsPaused(isPaused: boolean) {
    if(globalIsPaused) globalIsPaused(isPaused)
}

let globalRemainingPauseTimeMS: undefined | ((remainingPauseTimeMS: number | undefined) => void)
export function setGlobalRemainingPauseTimeMS(remainingPauseTimeMS: number | undefined) {
    if(globalRemainingPauseTimeMS) globalRemainingPauseTimeMS(remainingPauseTimeMS)
}

interface UIGamePauseProviderProps {
    children: ReactNode
}

export const UIGamePauseProvider = ({
    children,
}: UIGamePauseProviderProps) => {
    const [isPaused, setIsPaused] = useState(false)
    const [remainingPauseTimeMS, setRemainingPauseTimeMS] = useState<number | undefined>(undefined)
    const {sendTogglePause} = useUIGameSocketContext()
    const {isReplay} = useUIGameReplayContext()

    globalIsPaused = setIsPaused
    globalRemainingPauseTimeMS = setRemainingPauseTimeMS

    const requestPause = () => {
        if(isPaused) return
        if(isReplay) return

        sendTogglePause()
    }

    const requestResume = () => {
        if(!isPaused) return
        if(isReplay) return

        sendTogglePause()
    }

    return <UIGamePauseContext.Provider value={{
        isPaused: isPaused,
        remainingPauseTimeMS: remainingPauseTimeMS,
        requestPause: requestPause,
        requestResume: requestResume,
    }}>
        {children}
    </UIGamePauseContext.Provider>
}
